import { render, staticRenderFns } from "./AmeliaRanking.vue?vue&type=template&id=2da91dc2"
import script from "./AmeliaRanking.vue?vue&type=script&lang=js"
export * from "./AmeliaRanking.vue?vue&type=script&lang=js"
import style0 from "./AmeliaRanking.vue?vue&type=style&index=0&id=2da91dc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports